export default function calculateBaseOdds(nominalChancePercentage: number, tolerance: number = 1e-10, maxIterations: number = 1000): number {
  const nominalChance = nominalChancePercentage / 100;
  // With a flat chance p the expected tries would be 1/p.
  const target = 1 / nominalChance;
  // C is very small; we know it must lie between 0 and nominalChance.
  let low = 0;
  let high = nominalChance;
  let mid = 0;
  for (let iter = 0; iter < maxIterations; iter++) {
    mid = (low + high) / 2;
    const et = expectedTries(mid);
    if (Math.abs(et - target) < tolerance) {
      return mid * 100;
    }
    // expectedTries decreases as C increases.
    if (et > target) {
      // Too many tries mean C is too low; increase C.
      low = mid;
    } else {
      // Too few tries mean C is too high; decrease C.
      high = mid;
    }
  }
  return mid * 100;
}

function expectedTries(C: number): number {
  let sum = 0;
  let prod = 1;
  const maxTries = Math.floor(1 / C);
  // For attempts 1 to maxTries-1, success chance is i * C.
  for (let i = 1; i < maxTries; i++) {
    const p_i = prod * (i * C); // chance to succeed exactly on attempt i
    sum += i * p_i;
    prod *= (1 - i * C); // update failure probability up to this point
    // If prod becomes extremely small, we can break early.
    if (prod < 1e-15) break;
  }
  // On the last attempt, assume forced success.
  sum += maxTries * prod;
  return sum;
}
